/**
 * @deprecated use `import {presentationTool} from 'sanity/presentation`
 */
export function presentationTool(): void {
  throw new Error("Use `import {presentationTool} from 'sanity/presentation'` instead")
}
